import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bf75e1f8")

_pushScopeId("data-v-bf75e1f8")
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#common-layout" }),
  /*#__PURE__*/_createTextVNode(" Common Layout ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = { class: "common-layout" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Header")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Header")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Footer")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Aside")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Header")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Aside")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Header")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Aside")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Footer")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Aside")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Header")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Aside")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Header")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Main")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Footer")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_header = _resolveComponent("el-header")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_header, null, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_header, null, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_footer, null, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_aside, { width: "200px" }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_header, null, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withId(() => [
                _createVNode(_component_el_aside, { width: "200px" }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, null, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_header, null, {
              default: _withId(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withId(() => [
                _createVNode(_component_el_aside, { width: "200px" }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_container, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_main, null, {
                      default: _withId(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_footer, null, {
                      default: _withId(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_aside, { width: "200px" }, {
              default: _withId(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withId(() => [
                _createVNode(_component_el_header, null, {
                  default: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, null, {
                  default: _withId(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_aside, { width: "200px" }, {
              default: _withId(() => [
                _hoisted_22
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withId(() => [
                _createVNode(_component_el_header, null, {
                  default: _withId(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, null, {
                  default: _withId(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_footer, null, {
                  default: _withId(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
})